import * as React from 'react';
import { Helmet } from 'react-helmet';
import { Switch, Route, Redirect } from 'react-router-dom';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import GroupModal from 'components/GroupModal';

// Scenes
import Groups from './scenes/Groups';
// @ts-ignore
import People from './scenes/People';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const Workforce = (): React.ReactElement => (
    <ErrorBoundary
        namespace="Workforce"
        FallbackComponent={<ErrorBoundaryAlert />}
    >
        <Helmet>
            <title>
                {'Workforce - '}
                {REACT_APP_PROJECT_NAME}
            </title>
        </Helmet>
        <Switch>
            <Redirect
                exact
                from="/organization"
                to="/organization/workforce/people"
            />
            <Route
                exact
                path="/organization/workforce/people"
                component={People}
            />
            <Route
                exact
                path="/organization/workforce/groups"
                component={Groups}
            />
            <Redirect
                from="/organization"
                to="/organization/workforce/people"
            />
        </Switch>
        <GroupModal />
    </ErrorBoundary>
);

export default Workforce;
